export default "__VITE_ASSET__hU77QMn7__"